export { default } from "./PriceNoSSR";
